import jrpc20WSClient from "./jrpc20WSClient";

// Autenticazione portale Magazzino Packaging: solo badge, solo magazzinieri (qualifica 3).
// L'operatore delle operazioni è SEMPRE l'employee del token (nessuna tendina operatore).
// Chiavi localStorage dedicate ('lt_pkg' / 'pkg_user_info') per non collidere con gli
// altri portali (dipendenti/pf) che condividono lo stesso employeeportaltoken.
class employee {
    TOKEN_LS_KEY = 'lt_pkg';
    USER_INFO_LS_KEY = 'pkg_user_info';

    token = null;
    wsClient = new jrpc20WSClient(process.env.REACT_APP_BACKEND_WS_URL, process.env.REACT_APP_BACKEND_WS_USR, process.env.REACT_APP_BACKEND_WS_PWD)

    constructor() {
        this.token = localStorage.getItem(this.TOKEN_LS_KEY);
    }

    // Cache locale solo per display (nome, qualifica_label): mai usarla per autorizzare.
    getUserInfo() {
        try {
            return JSON.parse(localStorage.getItem(this.USER_INFO_LS_KEY));
        } catch (e) {
            return null;
        }
    }

    saveUserInfo(info) {
        localStorage.setItem(this.USER_INFO_LS_KEY, JSON.stringify(info));
    }

    // Verifica token + qualifica live via wsCheckToken (mai dalla cache). Il BE rifiuta
    // chi non è magazziniere: qui qualsiasi errore/qualifica assente => sessione non valida.
    isLogged() {
        return new Promise((resolve, reject) => {
            if (this.token == null) {
                reject();
                return;
            }
            const post_data = { user_data: { token: this.token }, call_data: {} };
            this.wsClient.request('post', 'warehouse/packagingWarehouse/wsCheckToken', post_data).then((result) => {
                const qualifica = result.call_data?.qualifica ?? null;
                if (qualifica === null) {
                    this.logout();
                    reject();
                    return;
                }
                const cached = this.getUserInfo() || {};
                this.saveUserInfo({
                    ...cached,
                    qualifica: qualifica,
                    qualifica_label: result.call_data?.qualifica_label ?? ''
                });
                resolve({
                    user_info: result.user_info,
                    qualifica: qualifica,
                    qualifica_label: result.call_data?.qualifica_label ?? ''
                });
            }).catch((error) => {
                reject(error);
            });
        });
    }

    // Login a badge. Il BE risolve la qualifica dal contratto e rifiuta i non-magazzinieri.
    authenticate(data) {
        return new Promise((resolve, reject) => {
            const post_data = { call_data: data };
            this.wsClient.request('post', 'warehouse/packagingWarehouse/wsAuthenticate', post_data).then((result) => {
                this.token = result.call_data.employee.token;
                localStorage.setItem(this.TOKEN_LS_KEY, this.token);
                this.saveUserInfo({
                    ...result.call_data.employee,
                    qualifica: result.call_data.qualifica,
                    qualifica_label: result.call_data.qualifica_label
                });
                resolve(result.call_data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    logout() {
        this.token = null;
        localStorage.removeItem(this.TOKEN_LS_KEY);
        localStorage.removeItem(this.USER_INFO_LS_KEY);
    }
}

export default employee;
